/*
 * Construção dos payloads de pedido. Regra de ouro: o front NUNCA envia
 * preço, desconto, frete ou total — quem calcula é o backend
 * (POST /api/orders/quote/ para exibir, POST /api/orders/ para persistir).
 */

const onlyDigits = (value) => (value || '').replace(/\D/g, '');

export const buildQuotePayload = (cart, { shippingType, zipCode }) => ({
  order_items: cart.map((item) => ({
    product_id: item.product.id,
    quantity: item.quantity,
    size_label: item.sizeLabel || '',
  })),
  shipping_type: shippingType || 'PICKUP',
  zip_code: onlyDigits(zipCode),
});

const base64ToFile = (base64String, filename) => {
  const [header, data] = base64String.split(',');
  const mime = (header.match(/:(.*?);/) || [])[1] || 'image/png';
  const binary = atob(data);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new File([bytes], filename, { type: mime });
};

export const buildOrderPayload = (formData, cart) => {
  const payload = new FormData();

  cart.forEach((item, index) => {
    payload.append(`order_items[${index}]product_id`, String(item.product.id));
    payload.append(`order_items[${index}]quantity`, String(item.quantity));
    if (item.sizeLabel) {
      payload.append(`order_items[${index}]size_label`, item.sizeLabel);
    }
    if (item.customImage && item.customImage.startsWith('data:image')) {
      payload.append(
        `order_items[${index}]image`,
        base64ToFile(item.customImage, `arte_${index}.png`)
      );
    }
  });

  payload.append('payment_method', formData.paymentMethod);
  payload.append('phone_number', formData.phone);
  payload.append('shipping_type', formData.shippingType);
  if (formData.notes) {
    // a UI chama "notes"; o campo do backend é "observation"
    payload.append('observation', formData.notes);
  }

  if (formData.shippingType === 'DELIVERY') {
    const address = [
      ['recipient_name', formData.recipientName],
      ['zip_code', onlyDigits(formData.zipCode)],
      ['state', formData.state],
      ['city', formData.city],
      ['neighborhood', formData.neighborhood],
      ['street', formData.street],
      ['number', formData.number],
      ['complement', formData.complement],
    ];
    address.forEach(([field, value]) => {
      if (value) payload.append(`shipping_address.${field}`, value);
    });
  }

  return payload;
};
